import { useMsal } from "@azure/msal-react";
import { addLocale } from "primereact/api";
import { useEffect, useState } from "react";

import { axiosGetRequest, axiosPostRequest } from "../../../api/ApiClient";
import DialogMessage from "../../../components/DialogMessage";
import InputLabelTextArea from "../../../components/InputLabelTextArea";
import { ptBrDatepickerTranslations } from "../../../i18n/locales/pt-br";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import {
    StyledInfoLabel,
    StyledInfoText,
} from "../../../styles/pages/Schedule/ModalViewDetailsStyles";
import GenericUtils from "../../../utils/GenericUtils";

addLocale("pt-BR", ptBrDatepickerTranslations);

const { BtnPrimary } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

export default function ContentAusencia(props: any) {
    const { setSuccessMessage } = props;
    const [justificativa, setJustificativa] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const acessToken = GenericUtils.getAccessTokenDocente();
    const [validacoes, setValidacoes] = useState<any>(null);
    const { instance } = useMsal();
    const [errorTitle, setErrorTitle] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    async function getValidacao() {
        const response = await axiosGetRequest(
            `/docente/v1/agendas/${props.props.detail.cartaoAgendaId}/validar-ausencia`,
            acessToken,
            instance
        );

        if (
            response?.data?.details &&
            typeof response.data.details === "string" &&
            response.data.details.includes("Hora Extra")
        ) {
            response.data.details = response.data.details.replace(
                "Hora Extra",
                "Hora Letiva RE"
            );
        }

        setValidacoes(response.data);
        setIsLoading(false);
    }

    useEffect(() => {
        getValidacao();
    }, []);

    const dialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorTitle)}
            title={errorTitle}
            text={errorMessage}
            onClose={() => {
                setErrorTitle("");
                setErrorMessage("");
            }}
        />
    );

    const handleSendJustificativa = async () => {
        const response = await axiosPostRequest(
            `/docente/v1/agendas/${props.props.detail.cartaoAgendaId}/justificar-ausencia`,
            {
                mensagem: justificativa,
            },
            acessToken,
            instance
        );

        if (response.status === 201) {
            setSuccessMessage(true);
        } else {
            setErrorTitle("Erro ao Justificar.");
            setErrorMessage(response.data.details);
        }
    };

    return (
        <>
            <div>
                <StyledInfoLabel>Justificativa</StyledInfoLabel>
                <InputLabelTextArea
                    value={justificativa}
                    placeholder="Insira sua justificativa. Tamanho mínimo de 10 caracteres."
                    onChange={(event: any) =>
                        setJustificativa(event.target.value as string)
                    }
                    viewLengthInfo
                    maxLength={200}
                    style={{
                        height: "107px",
                        borderStyle: "solid",
                        borderColor: "#787878",
                    }}
                />
            </div>
            <StyledInfoText
                style={{
                    color: "red",
                }}
            >
                {validacoes?.code === 400 ? validacoes?.details : ""}
            </StyledInfoText>
            <StyledContainerButton className="mt-3">
                <BtnPrimary
                    disabled={
                        isLoading ||
                        validacoes?.code === 400 ||
                        justificativa.toString().length < 10
                    }
                    onClick={handleSendJustificativa}
                >
                    Justificar
                </BtnPrimary>
            </StyledContainerButton>
            {errorMessage && dialogError}
        </>
    );
}
